// @ts-check

import React from 'react';
import { array, func, object } from 'prop-types';
import USER from '../ts/profileEditorEnum';
import ProfilePaper from './ProfilePaper';
import Grid from '@mui/material/Grid';
import CompanySelector from './CompanySelector';
import AccessibleSelector from './AccessibleSelector';
import Typography from '@mui/material/Typography';

/**
 * @component ProfileEditorCompany
 * @param {Object} props
 * @param {EditorUserType} props.editorUser
 * @param {EditorUserValidType} props.valid
 * @param {CompanyType[]} props.companies
 * @param {CompanyType[]} props.accessibleData
 * @param {(name:string, payload: any)=>void} props.onHandle
 * @returns {JSX.Element}
 */
function ProfileEditorCompany({ editorUser, valid, companies, accessibleData, onHandle }) {
	return (
		<ProfilePaper>
			<Typography variant="button">COMPANY</Typography>
			<Grid container spacing={2}>
				<Grid item lg={6} xs={12}>
					<CompanySelector
						values={editorUser[USER.COMPANIES]}
						options={companies}
						valid={valid[USER.COMPANIES]}
						onHandleUser={onHandle}
					/>
				</Grid>
				<Grid item lg={6} xs={12}>
					<AccessibleSelector
						value={editorUser[USER.ACCESSIBLE]}
						options={accessibleData}
						valid={valid[USER.ACCESSIBLE]}
						onHandle={onHandle}
					/>
				</Grid>
			</Grid>
		</ProfilePaper>
	);
}

ProfileEditorCompany.propTypes = {
	editorUser: object,
	valid: object,
	companies: array,
	accessibleData: array,
	onHandle: func,
};

export default ProfileEditorCompany;
